import { render, staticRenderFns } from "./BudgetCategorieModal.vue?vue&type=template&id=bfb5c608&scoped=true&"
import script from "./BudgetCategorieModal.vue?vue&type=script&lang=js&"
export * from "./BudgetCategorieModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb5c608",
  null
  
)

export default component.exports